<template>
  <div v-if="advertisingChannel.supports_frequency_capping_targeting" class="freq-capping">

    <div class="vx-row">
      <div class="vx-col w-full mb-6">
        <h4>
          {{ $t('Frequency Capping') }}
        </h4>

        <p class="mt-4 text-md text-gray-600">
          {{ $t('This indicates the maximum number of times you want to display your ad to unique users per 24 hours.') }}
        </p>
      </div>

      <div class="vx-col md:w-2/3 w-full mb-6">
        <v-select @input="$gtag.event('Step3_AdvTab_Freq')" id="create-campaign-s3-frequency-list" v-model="value.frequency_capping" :reduce="i => i.id" :options="options" :placeholder="$t('Not Selected')" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
        <!-- <vs-select :placeholder="$t('Select number')" v-model="value.frequency_capping"  class="w-full select-large">
          <vs-select-item :key="'frequency_capping-' + n" :value="n - 1" :text="n - 1" v-for="n in 11" class="w-full" />
        </vs-select> -->

      </div>
    </div>
  </div>
</template>

<script>
import TargetDevices from './TargetDevices.vue'

export default {
  props: {
    value: {
      type: Object,
      required: true
    },
    adsetIndex: {
      type: Number,
      required: true
    },
    advertisingChannel: {
      type: Object,
      required: true
    }
  },
  watch: {
    value: {
      handler (newVal) {
        this.$emit('input', newVal)
      },
      deep: true
    }
  },
  computed: {
    options () {
      const options = []

      for (let i = 0; i < 11; i++) {
        options.push({
          id: i,
          label: i
        })
      }

      return options
    }
  },
  components: {
    TargetDevices
  }
}
</script>
